// extracted by mini-css-extract-plugin
export var pillWrapper = "_nu-0";
export var showOverflow = "_nu-1";